import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../ts/ServerApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../ts/ServerApi/types/IGetItemsResult';
import { IDatasourceRevision } from '../types/IDatasourceRevision';

export interface IGetDatasourceVersionsParams extends IGetItemsParams {
}

export interface IGetDatasourceVersionsResult extends IGetItemsResult {
  versions: IDatasourceRevision[];
}

export class GetDatasourceVersionsRequest extends Request<IGetDatasourceVersionsParams, IGetDatasourceVersionsResult> {
  constructor(params: IGetDatasourceVersionsParams) {
    super('getDatasourceVersions', params);
  }
}
